import { useState } from "react";
import { Receipt, Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { money } from "@/lib/format";

const STATUSES = ["New", "In Progress", "Delivered", "Invoiced"];

export const BulkBar = ({ count, billable, busy, onStatus, onDelete, onBill, onClear }) => {
  const [pick, setPick] = useState("");
  if (!count) return null;
  return (
    <div className="px-4 py-3 flex flex-wrap items-center gap-2 border-b border-blue-200 bg-blue-50/70" data-testid="bulk-bar">
      <span className="text-sm font-semibold text-[#002FA7] mr-1" data-testid="bulk-count">{count} selected</span>
      <Button size="sm" variant="ghost" onClick={onClear} disabled={busy} data-testid="bulk-clear"><X className="w-4 h-4 mr-1" /> Clear</Button>
      <div className="flex items-center gap-2">
        <Select value={pick} onValueChange={setPick} disabled={busy}>
          <SelectTrigger className="h-8 w-[150px] bg-white" data-testid="bulk-status-select"><SelectValue placeholder="Change status…" /></SelectTrigger>
          <SelectContent>
            {STATUSES.map((s) => <SelectItem key={s} value={s} data-testid={`bulk-status-option-${s.toLowerCase().replace(" ", "-")}`}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <Button size="sm" variant="outline" className="bg-white" disabled={!pick || busy} onClick={() => onStatus(pick).then(() => setPick(""))} data-testid="bulk-status-apply">Apply</Button>
      </div>
      <Button size="sm" variant="outline" className="bg-white text-rose-600 border-rose-200 hover:bg-rose-50" disabled={busy} onClick={onDelete} data-testid="bulk-delete-btn"><Trash2 className="w-4 h-4 mr-1" /> Delete</Button>
      {billable.length > 0 && (
        <Button size="sm" onClick={onBill} disabled={busy} className="sm:ml-auto bg-[#002FA7] hover:bg-[#001A75] rounded-full" data-testid="bill-selected-btn">
          <Receipt className="w-4 h-4 mr-1" /> Bill {billable.length} ready · {money(billable.reduce((s, l) => s + (Number(l.billable_total ?? l.rate) || 0), 0))}
        </Button>
      )}
    </div>
  );
};
